import React, { Component } from 'react';
import Translation from "../../../../shared/Translation";
import WithCurrencyConfig from '../../../config/WithCurrencyConfig';
import { getJSFormattedCurrency } from '@h/currency';

class Donation extends Component {
    getFormattedCurrency = amount => {
      return this.props.currencyConfig ? getJSFormattedCurrency(amount, this.props.currencyConfig) : '';
    }
    render() {

        let donationDescription = "checkout__make_additional_donation";
        let suggestion = '';

        if (this.props.organization.fixed) {
            if (this.props.organization.per_tik) {
                donationDescription = "checkout__make_additional_donation_to_organization_fixed_per_ticket";
            } else {
                donationDescription = "checkout__make_additional_donation_to_organization_fixed";
            }
        } else {
            if (this.props.organization.per_tik) {
                donationDescription = "checkout__make_additional_donation_per_ticket";
            } else {
                if (this.props.organization.suggested_amount) {
                    suggestion = "checkout__additional_donation_suggestion";
                }
            }
        }
      donationDescription = this.props.organization.fixed ? donationDescription + '_check_box' : donationDescription + '_enter_amount';
      const id = `donation-${this.props.organization.event_id}`;
      const label = <span><Translation interpolation={{boldStart:"<strong>", boldEnd:"</strong>", donation_amount:this.getFormattedCurrency(this.props.organization.fixed), organization_name:this.props.organization.name}}>{donationDescription}</Translation> <Translation interpolation={{suggested_amount:this.getFormattedCurrency(this.props.organization.suggested_amount)}}>{suggestion}</Translation></span>;
        const input = this.props.organization.fixed
        ? <input
            id={id}
            type="checkbox"
            name="donation"
            checked={this.props.value ? true : false}
            readOnly/>
        : <input
            id={id}
            className="input__control input--donation-number"
            type="number"
            name="donation"
            min="0.00"
            step="0.01"
            placeholder="0.00"
            value={this.props.value ? this.props.value : ''}
            onChange={(e) => this.props.onChange(this.props.organization.event_id, e)}/>;

        const inputContainerClasses = this.props.organization.fixed && this.props.value
        ? 'checkout-form__donation checkbox--selected'
        : 'checkout-form__donation';

        return(

            <div className="input">
                <div className={inputContainerClasses} onClick={this.props.organization.fixed ? () => this.props.onChange(this.props.organization.event_id) : null}>
                    <div className="input__horizontal">
                        <label className="input__label" htmlFor={id}>{label}</label>
                        {input}
                    </div>
                </div>
            </div>

        );
    }

}

export default (WithCurrencyConfig(Donation));
